import { ShipmentModel } from "features/shared/shipmentCard.types";
import { usePanelViews } from "features/shared/usePanelViews.hook";
import { appStore } from "entities/App";
import { authStore } from "entities/Auth";
import { parcelCardDeleteModalStore } from "entities/ParcelCardDeleteModal";
import { isParcelSearchShipmentModel, ParcelSearchCardModel, parcelSearchCardStore } from "entities/ParcelSearchCard";
import { voidFunc } from "shared/lib/common.lib";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";
import { Nullable } from "shared/lib/typeCheck.lib";

type ShipmentCardModel = ParcelSearchCardModel;

// type FollowFunc = (card: RailSearchCardModel) => void;
type AskDeletingCardFunc = (card: ShipmentCardModel) => void;
type DeleteCardHandler = (card: ShipmentCardModel) => void;
type CancelDeletingSavedCardFunc = () => void;
type DeleteCardModalHandlerFunc = () => void;
type UseParcelCardActionsReturnType = {
  deleteParcelCardHandler: DeleteCardHandler;
  deleteParcelCardModalHandler: DeleteCardModalHandlerFunc;
  cancelParcelCardDeleting: CancelDeletingSavedCardFunc;
  //   parcelCardFollow: FollowFunc;
  //   isParcelCardFollowLoading: boolean;
  //   isParcelCardFollowButtonVisible: boolean;
  isParcelCardDeleting: boolean;
};

type UseParcelCardActionsParams = {
  cardToDelete?: Nullable<ShipmentModel>;
  setCardToDeleteAction?: (card: ShipmentModel) => {
    type: string;
    payload: ShipmentModel | null;
  };
  resetCardToDeleteAction?: () => {
    type: string;
  };
  //   removeFilteredCardAction: (
  //     cards: SeaSavedCardModel | AirSavedCardModel | ParcelSearchCardModel
  //   ) => PayloadAction<SeaSavedCardModel | AirSavedCardModel | RailSearchCardModel>;
  //   removeCardByTagAction: (
  //     cards: SeaSavedCardModel | AirSavedCardModel | ParcelSearchCardModel
  //   ) => PayloadAction<SeaSavedCardModel | AirSavedCardModel | RailSearchCardModel>;
  //   refreshTags: () => void;
};
export const useParcelCardActions = ({
  cardToDelete,
  setCardToDeleteAction,
  resetCardToDeleteAction,
  //   removeFilteredCardAction,
  //   removeCardByTagAction,
  //   refreshTags,
}: UseParcelCardActionsParams): UseParcelCardActionsReturnType => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(authStore.selectors.isAuthenticated);
  const requestedFromUrl = useAppSelector(appStore.selectors.requestedFromUrl);
  //   const savedCards = useAppSelector(railSavedCardStore.selectors.savedCards);
  const searchCards = useAppSelector(parcelSearchCardStore.selectors.searchCards);
  const { showPreviousView, isCurrentViewOpenedCard } = usePanelViews();

  //   const removeSavedCardFromUI = (card: ParcelSearchCardModel) => {
  // dispatch(parcelSavedCardStore.actions.removeSavedCardAction(card));
  // dispatch(removeFilteredCardAction(card));
  // dispatch(removeCardByTagAction(card));
  //   };

  const resetDeleteModal = () => {
    dispatch(parcelCardDeleteModalStore.actions.closeDeleteModalAction());
    if (resetCardToDeleteAction) {
      dispatch(resetCardToDeleteAction());
    }
  };

  const handleModalDeleting = () => {
    resetDeleteModal();
    if (isAuthenticated) {
      //   refreshTags();
    }
    if (isCurrentViewOpenedCard) {
      showPreviousView();
    }
  };

  const askDeletingCard: AskDeletingCardFunc = (card) => {
    dispatch(parcelCardDeleteModalStore.actions.openDeleteCardModalAction());
    if (setCardToDeleteAction) {
      dispatch(setCardToDeleteAction(card));
    }
  };

  const createParcelCardDeleteHandlers = (): {
    deleteParcelCardHandler: DeleteCardHandler;
    deleteParcelCardModalHandler: DeleteCardModalHandlerFunc;
  } => {
    // case 1: opened from url (and clicked delete button)
    if (isCurrentViewOpenedCard && requestedFromUrl) {
      return {
        deleteParcelCardHandler: (card) => {
          askDeletingCard(card);
        },
        deleteParcelCardModalHandler: () => {
          if (!cardToDelete) {
            handleModalDeleting();
            return;
          }

          if (!isAuthenticated && isParcelSearchShipmentModel(cardToDelete)) {
            dispatch(parcelSearchCardStore.actions.removeSearchCardAction(cardToDelete));
            handleModalDeleting();
            return;
          }

          if (isAuthenticated && isParcelSearchShipmentModel(cardToDelete) && cardToDelete.reference) {
            // const existingSavedCard = savedCards.find((c) => c.reference === cardToDelete.reference);

            // if (existingSavedCard) {
            //   deleteSavedCardRequest(existingSavedCard.id, {
            //     onSettled: () => {
            //       removeSavedCardFromUI(existingSavedCard);
            //       handleModalDeleting();
            //     },
            //   });
            //   return;
            // }

            const existingSearchCard = searchCards.find((c) => c.reference === cardToDelete.reference);

            if (existingSearchCard) {
              dispatch(parcelSearchCardStore.actions.removeSearchCardAction(cardToDelete));
              handleModalDeleting();
            }

            // getCards(
            //   { limit: 1, where: { reference: cardToDelete.reference } },
            //   {
            //     onSettled: (response) => {
            //       if (response?.length) {
            //         deleteSavedCardRequest(response[0].id, {
            //           onSettled: () => {
            //             removeCardsCache();
            //             handleModalDeleting();
            //           },
            //         });
            //       }
            //     },
            //   }
            // );
            return;
          }

          //   if (isRailSavedShipmentModel(cardToDelete)) {
          //     removeSavedCardFromUI(cardToDelete);
          //     deleteSavedCardRequest(cardToDelete.id, {
          //       onSettled: () => handleModalDeleting(),
          //     });
          //   }
        },
      };
    }

    // case 2: clicked delete button on openned card or closed card
    if (!requestedFromUrl) {
      return {
        deleteParcelCardHandler: (card) => {
          askDeletingCard(card);
        },
        deleteParcelCardModalHandler: () => {
          //   if (isRailSearchShipmentModel(cardToDelete)) {
          //     deleteSavedCardRequest(cardToDelete.id, {
          //       onSettled: () => {
          //         removeSavedCardFromUI(cardToDelete);
          //         handleModalDeleting();
          //       },
          //     });
          //     return;
          //   }
          if (isParcelSearchShipmentModel(cardToDelete)) {
            dispatch(parcelSearchCardStore.actions.removeSearchCardAction(cardToDelete));
            handleModalDeleting();
            return;
          }
        },
      };
    }

    return {
      deleteParcelCardHandler: voidFunc,
      deleteParcelCardModalHandler: voidFunc,
    };
  };

  //   const follow: FollowFunc = (data) => {
  //     if (!data || !data?.reference) return;
  //     const { atd, etd, ata, eta, predictiveETA } = data;
  //     const { departureDate, arrivalDate } = resolveDateValues({ atd, etd, ata, eta, predictiveETA });
  //     const departureDateWithLocale = departureDate.value ? formatFollowCardDate(departureDate.value) : null;
  //     const arrivalDateWithLocale = arrivalDate.value ? formatFollowCardDate(arrivalDate.value) : null;

  //     followCard(
  //       {
  //         reference: data.reference,
  //         location: {
  //           pin: data.currentPin,
  //           from: data.fromDirection ?? null,
  //           to: data.toDirection ?? null,
  //           // TODO: replace with API data
  //           transport: SeaRouteTypesModel.SEA,
  //         },
  //         type: data.referenceType,
  //         equipments_count: data.containersAmount,
  //         carrier_scac: data.getCarrierScac(),
  //         carrier_name: data.carrierName ?? null,
  //         status: data.status ?? ShipmentStatusesModel.UNKNOWN,
  //         size_type: JSON.stringify(data.containersSizeTypes),
  //         date: {
  //           from_actual: departureDate.isActual,
  //           from: departureDateWithLocale,
  //           to_actual: arrivalDate.isActual,
  //           to: arrivalDate.isPredictive ? null : arrivalDateWithLocale,
  //           to_predictive: arrivalDate.isPredictive ? arrivalDate.value : null,
  //         },
  //         updated_at: formatApiDate(new Date()),
  //       },
  //       {
  //         onSuccess: (response) => {
  //           dispatch(seaSearchCardStore.actions.removeSearchCardAction(data));
  //           dispatch(seaSavedCardStore.actions.prependSavedCardAction({ data: response }));
  //         },
  //       }
  //     );
  //   };

  const cancelParcelCardDeleting: CancelDeletingSavedCardFunc = () => {
    // if (isSavedCardDeleting) return;
    resetDeleteModal();
  };

  return {
    ...createParcelCardDeleteHandlers(),
    cancelParcelCardDeleting,
    // TODO: replace with real value
    isParcelCardDeleting: false,
    // parcelCardFollow: follow,
    // isParcelCardFollowLoading: isCardFollowLoading,
    // isParcelCardFollowButtonVisible: typeof followedCard === "undefined" && isAuthenticated,
    // isParcelCardDeleting: isSavedCardDeleting,
  };
};
